/** @format */

import { Link, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { GA4_COMPONENT_NAME, GA4_COMPONENT_POSITION, GA4_COMPONENT_TYPE } from 'src/analytics/componentInteractionGa4';
import getRedirectionLink, { toSameOriginPath } from 'src/utils/helper';
import { Button } from 'src/components/button';
import { API_URL } from 'src/constants';
import useGa4Analytics from 'src/hooks/useGa4Analytics';

const HeroWidget = props => {
  const { w, h, title, content, image: dataImage, link, linkTarget, linkTitle } = props.data;
  const image = API_URL + dataImage;
  const navigate = useNavigate();
  const { trackComponentInteraction } = useGa4Analytics();

  const handleHeroCtaClick = useCallback(() => {
    trackComponentInteraction({
      component_name: GA4_COMPONENT_NAME.HERO_CTA,
      component_type: GA4_COMPONENT_TYPE.BUTTON,
      component_position: GA4_COMPONENT_POSITION.HERO
    });
  }, [trackComponentInteraction]);

  const handleButtonClick = () => {
    handleHeroCtaClick();
    if (linkTarget === '_blank') {
      window.open(link, '_blank');
      return;
    }

    if (link.startsWith(window.location.origin)) {
      navigate(toSameOriginPath(link));
      return;
    }

    window.location.href = link;
  };

  return (
    <div className="hero-widget" data-width={w} data-height={h}>
      {image && <img className="hero-widget-image" src={image} alt={title} />}
      <div className="hero-widget-inner">
        <h2 className="hero-widget-title" title={title}>
          {title}
        </h2>
        <div className="hero-widget-content" title={content}>
          {content}
        </div>
        <div className="hero-widget-link">
          {link ? (
            <Button label={linkTitle} onClick={handleButtonClick} />
          ) : (
            <Link to={getRedirectionLink(props.data)}>
              <Button label={linkTitle} onClick={handleHeroCtaClick} />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export { HeroWidget };
